import { PageHeader } from "@/components/page";
import { useRoleProtected } from "@/hooks/useRoleProtected";
import { useUserStore } from "@/stores/userStore";
import { DataTableWrapper } from "@repo/ui/components/Base/DataTable";
import { AgendaTemplateTable } from "@/components/agendaTemplate/AgendaTemplateTable";
import { useNavigate, useParams } from "react-router-dom";
import { AppUrlPath } from "@/lib/AppUrlPath";
import { Tooltip } from "@repo/ui/components/Base/Tooltip";
import { CreateTriggerButton } from "@repo/ui/components/Base/CreateTriggerButton";
import { useGetTenantByFriendly } from "@/hooks/queryHooks/tenantHooks";

export const AgendaTemplatesPage = () => {
  useRoleProtected("admin");
  const { tenantId } = useParams();
  const { data: tenantData } = useGetTenantByFriendly(tenantId ?? "");
  const activeTeam = useUserStore((s) => s.activeTeam);

  const navigate = useNavigate();

  if (!tenantId || !tenantData) return null;

  const isFullOrg = activeTeam === "org";

  return (
    <div className="flex flex-col flex-grow">
      <PageHeader
        title={
          tenantData.name
            ? `${tenantData.name}'s Agenda Templates`
            : "Agenda Templates"
        }
      >
        {activeTeam === "org" && (
          <p className="text-red-500 w-0 flex-grow-[3] mr-8 text-balance text-right">
            You must select a team to be able to edit and create agenda
            templates.
          </p>
        )}
        <Tooltip
          label={
            isFullOrg
              ? "Select a team to create a template"
              : "Create a Template"
          }
          tooltipTriggerProps={{ disabled: isFullOrg }}
          asChild
        >
          <CreateTriggerButton
            disabled={isFullOrg}
            onClick={() => {
              navigate(
                new AppUrlPath(tenantId).getAgendaTemplatePath("create")
              );
            }}
          />
        </Tooltip>
      </PageHeader>
      <DataTableWrapper>
        <AgendaTemplateTable tenantId={tenantData.id} />
      </DataTableWrapper>
    </div>
  );
};
